import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import GotoTop from "../common/GotoTop";
import ContactCTA from "../contact/contactCTA";
import About from "./About";
import Carousel from "./Carousel";
import Faq from "./Faq";
import Features from "./Features";
import Highlight from "./Highlight";

const Home = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Flint Infotech - IT Consulting & Web Development Services
          </title>
          <meta
            name="description"
            content="Flint Infotech offers expert IT services, consulting, web development, and database migration solutions. Transform your ideas into digital reality with our responsive design services."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />

          <meta
            property="og:title"
            content="Flint Infotech - IT Consulting & Web Development Services"
          />
          <meta
            property="og:description"
            content="Flint Infotech offers expert IT services, consulting, web development, and database migration solutions. Transform your ideas into digital reality with our responsive design services."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://flintinfotech.com/" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Flint Infotech - IT Consulting & Web Development Services"
          />
          <meta
            name="twitter:description"
            content="Flint Infotech offers expert IT services, consulting, web development, and database migration solutions. Transform your ideas into digital reality with our responsive design services."
          />

          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <div>
        <Carousel />
        <ScrollSpy>
          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <About />
          </AnimationOnScroll>
          {/* <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInLeft"> */}
          <Features />
          {/* </AnimationOnScroll> */}
          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <Highlight />
          </AnimationOnScroll>
          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <Faq />
          </AnimationOnScroll>
          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <ContactCTA />
          </AnimationOnScroll>
        </ScrollSpy>
        <GotoTop />
      </div>
    </div>
  );
};

export default Home;
